'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import { useClipboard } from '@common/hooks';
import SvgAlignBack from '@common/icon/SvgAlignBack';
import SvgShare2 from '@common/icon/SvgShare2';
import { cn } from '@core/utils';
import { useShallow } from 'zustand/react/shallow';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { INVITE_SHARE_CONTENT } from '@/app/(allowed)/benefit/invite/_utils/inviteShare';
import { BASE_URL, DONATION_ROUTES, ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { inviteLinkOf } from './inviteLinkOf';
const FIELD_CLASS_NAME = 'flex h-48 min-w-0 flex-1 items-center gap-8 rounded-small bg-Gray-white px-16 text-Gray-900 typo-body3';
const FIELD_INTERACTION_CLASS_NAME = cn('text-left transition-colors duration-150 motion-reduce:transition-none', FOCUS_RING);
const SHARE_BUTTON_CLASS_NAME = cn('flex size-48 shrink-0 items-center justify-center rounded-small border border-Gray-white/40 bg-Gray-white/20', 'transition-colors duration-150 motion-reduce:transition-none', 'mobile-tablet:border-Gray-white/60', FOCUS_RING);
export const InviteLinkActions = () => {
  const $ = _c(36);
  const [isLogin, memberCode] = useAuthStore(useShallow(_temp));
  const copy = useClipboard();
  if (isLogin === false) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = ROUTES.LOGIN.withSearchParams({
        searchParams: {
          redirect: DONATION_ROUTES.HOME.pathname
        }
      });
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    const loginHref = t0;
    let t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = cn(FIELD_CLASS_NAME, FIELD_INTERACTION_CLASS_NAME, "hover:bg-Gray-50 active:bg-Gray-100");
      t2 = <span className="min-w-0 flex-1 truncate text-Gray-500">로그인하고 초대 링크 받기</span>;
      t3 = <SvgAlignBack className="size-16 shrink-0 text-Gray-900" />;
      $[1] = t1;
      $[2] = t2;
      $[3] = t3;
    } else {
      t1 = $[1];
      t2 = $[2];
      t3 = $[3];
    }
    let t4;
    if ($[4] !== loginHref) {
      t4 = <CustomLink prefetch={false} href={loginHref} className={t1}>{t2}{t3}</CustomLink>;
      $[4] = loginHref;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = cn(SHARE_BUTTON_CLASS_NAME, "hover:bg-Gray-white/30 active:bg-Gray-white/40");
      t6 = <SvgShare2 className="size-20 text-Gray-white" />;
      $[6] = t5;
      $[7] = t6;
    } else {
      t5 = $[6];
      t6 = $[7];
    }
    let t7;
    if ($[8] !== loginHref) {
      t7 = <CustomLink prefetch={false} href={loginHref} aria-label={"\uB85C\uADF8\uC778\uD558\uACE0 \uCD08\uB300 \uB9C1\uD06C \uACF5\uC720\uD558\uAE30"} className={t5}>{t6}</CustomLink>;
      $[8] = loginHref;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== t4 || $[11] !== t7) {
      t8 = <>{t4}{t7}</>;
      $[10] = t4;
      $[11] = t7;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    return t8;
  }
  let t0;
  if ($[13] !== memberCode) {
    t0 = memberCode ? inviteLinkOf(BASE_URL, memberCode) : null;
    $[13] = memberCode;
    $[14] = t0;
  } else {
    t0 = $[14];
  }
  const inviteLink = t0;
  const t1 = !inviteLink;
  let t2;
  if ($[15] !== copy || $[16] !== inviteLink) {
    t2 = () => {
      if (inviteLink) {
        copy({
          value: inviteLink.href,
          message: "\uCD08\uB300 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD588\uC5B4\uC694"
        });
      }
    };
    $[15] = copy;
    $[16] = inviteLink;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(FIELD_CLASS_NAME, FIELD_INTERACTION_CLASS_NAME, "enabled:hover:bg-Gray-50 enabled:active:bg-Gray-100");
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  const t4 = inviteLink?.label ?? "-";
  let t5;
  if ($[19] !== t4) {
    t5 = <span className="min-w-0 flex-1 truncate">{t4}</span>;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgAlignBack className="size-16 shrink-0 text-Gray-900" />;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t1 || $[23] !== t2 || $[24] !== t5) {
    t7 = <button type="button" disabled={t1} aria-label={"\uB0B4 \uCD08\uB300 \uB9C1\uD06C \uBCF5\uC0AC\uD558\uAE30"} onClick={t2} className={t3}>{t5}{t6}</button>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t5;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const t8 = !inviteLink;
  let t9;
  if ($[26] !== inviteLink) {
    t9 = () => {
      if (inviteLink) {
        openShareDrawer(inviteLink.href, INVITE_SHARE_CONTENT);
      }
    };
    $[26] = inviteLink;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn(SHARE_BUTTON_CLASS_NAME, "enabled:hover:bg-Gray-white/30 enabled:active:bg-Gray-white/40");
    t11 = <SvgShare2 className="size-20 text-Gray-white" />;
    $[28] = t10;
    $[29] = t11;
  } else {
    t10 = $[28];
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t8 || $[31] !== t9) {
    t12 = <button type="button" disabled={t8} aria-label={"\uCD08\uB300 \uB9C1\uD06C \uACF5\uC720\uD558\uAE30"} onClick={t9} className={t10}>{t11}</button>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[33] = t12;
    $[34] = t7;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
function _temp(state) {
  return [state.isLogin, state.myInfo?.memberCode];
}